import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/jobs/jobsReportActions'
import * as api from '../../../api/reports/jobs/jobsReports'

function* jobsReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({ type: constants.JOBS_REPORT_GET_ORGANIZATION_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOBS_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* jobsReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.JOBS_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOBS_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */

function* watchjobsReportGetOrganizationList() {
  yield takeLatest(
    constants.JOBS_REPORT_GET_ORGANIZATION_LIST.ACTION,
    jobsReportGetOrganizationList
  )
}

function* watchjobsReportGetFullReport() {
  yield takeLatest(constants.JOBS_REPORT_GET_FULL_REPORT.ACTION, jobsReportGetFullReport)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([fork(watchjobsReportGetOrganizationList), fork(watchjobsReportGetFullReport)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/jobs/jobsReportSaga.js